<template>
<!-- ↓ 登录页 LogInPage -->
<div class="LogInPage-wrap full-size flex-center">
  <ul class="log-wrap flex-center radius-5">
    <li class="left-img full-height">

    </li>
    <li class="right-log-wrap full-height flex-center fd-col">
      <img src="../assets/img/cloud.png" class="cloud-img">
      <!-- ↓ 登录区域 -->
      <div class="log-box flex-box fd-col">
        <h4 class="title">账号密码登录</h4>
				<!-- <h6 class="sub-title">欢迎使用合肥视尔智能导办后台管理系统</h6> -->
				<h6 class="sub-title">视尔业务数据统一管理系统</h6>
        <div class="inp-box full-width flex-center">
          <i class="label-icon iconfont icon-avatar"></i>
					<input class="inp full-width" placeholder="用户名 / 邮箱 / 手机号"
            type="text"
            v-model="username"
            @focus="addFocusStyle($event)"
            @blur="removeFocusStyle($event)">
        </div>
        <div class="inp-box PW-inp-box full-width flex-center">
          <i class="label-icon iconfont icon-password"></i>
					<input class="inp full-width" placeholder="密码"
            maxlength="20"
            :type="passwordType"
            v-model="password"
            @focus="addFocusStyle($event)"
            @blur="removeFocusStyle($event)">
          <i class="iconfont toggle-seen-btn flex-center"
            :class="passwordIcon"
            @click="toggleSeen">
          </i>
        </div>
        <div class="autoLog-box">
          <el-checkbox
            v-model="isAutoLogIn"
            :true-label="1"
            :false-label="0">
            下次自动登录
          </el-checkbox>
        </div>

        <div class="logIn-btn-wrap full-width flex-center">
          <div class="logIn-btn full-width"
            :class="inLogging ? 'disabled':''"
            @click="logIn">
            {{inLogging ? '':'登录'}}
          </div>
          <i class="iconfont icon-loading circle-animate flex-center"
            :style="{'display': inLogging ? 'block' : 'none'}">
          </i>
        </div>
      </div>
    </li>
  </ul>
</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'LogInPage',
  data(){
    return {
      passwordType: 'password',
      passwordIcon: 'icon-hide',
      username: '',
      password: '',
      isAutoLogIn: 0,   // 是否自动登录
      inLogging: false, // 是否在登录中
    }
  },
  metaInfo: {
    title: '登录'
  },
  computed: {
    ...mapState({
      user: state => state.user,
    })
  },
  created(){
    const cookieUsername = this.globalFn.getCookie('username');
    const cookiePassword = this.globalFn.getCookie('password');
    const isAutoLogIn = this.globalFn.getCookie('isAutoLogIn');
    console.log("this.globalFn.getCookie('isAutoLogIn'):", isAutoLogIn);
    this.username = cookieUsername ? cookieUsername : '';
    this.password = cookiePassword ? cookiePassword : '';
    this.isAutoLogIn = isAutoLogIn ? parseInt(isAutoLogIn) : 0;
    document.addEventListener('keyup',this.enterLogin);
  },
  beforeDestroy(){
    document.removeEventListener('keyup',this.enterLogin);
  },
  methods:{
    /*--------------------- ↓ 输入框focus时，添加样式 --------------------*/
    addFocusStyle(ev){
      const faEle = ev.target.parentElement;
      faEle.classList.add('focus');
    },
    /*--------------------- ↓ 输入框blur时，删除样式 ---------------------*/
    removeFocusStyle(ev){
      const faEle = ev.target.parentElement;
      faEle.classList.remove('focus');
    },
    /*----------------------- ↓ 切换密码 暗文/明文 -----------------------*/
    toggleSeen(){
      this.passwordType = this.passwordType == 'password' ? 'text' : 'password';
      this.passwordIcon = this.passwordIcon == 'icon-hide' ? 'icon-eye' : 'icon-hide';
    },

    /*------------------------- ↓ enter键 登录 --------------------------*/
    enterLogin(e){
      let ev = e || window.event;
      if (ev.code == 'Enter') this.logIn();
    },
    /*------------------------------ ↓ 登录 -----------------------------*/
    logIn(){
      if(this.inLogging){ return }; // 如果正处于登录请求中，阻止再次请求
      console.log('enter');
      if(!this.username || !this.username.trim()){
        this.showMES('请输入用户名','warning');
        return;
      };
      if(!this.password){
        this.showMES('请输入密码','warning');
        return;
      }
      else if(!this.password.trim()){
        this.showMES('密码不可全为空','warning');
        return;
      }
      // else if(this.password.length < 6 || this.password.length > 12){
      else if(this.password.length < 6 || this.password.length > 20){
        this.showMES('密码为 6 - 20 位', 'warning');
        return;
      };
      if(this.isAutoLogIn == 1){
        this.setCookie();
      }else{
        this.globalFn.clearCookie();
      };

      this.inLogging = true;
      this.globalFn.axiosPost({
        url: this.Api.logIn,
        data:{
          username: this.username,
          password: this.password
        },
        failTip: '登录失败',
        success: res => {
          console.log('登录成功 res:',res);
          this.logInSuccess(res.data.data);
        },
				complete: res => this.inLogging = false
      });
    },
    /*---------------------------- ↓ 登录成功 ----------------------------*/
    logInSuccess(data){
      this.globalFn.msgCloseAll();  // 清空其他消息提示
      this.setFullSizeLoading(false);
      // this.showMES('登录成功', 'success');
      this.setLogonStatus(1);
      this.setAsideTree({
        json: [],
        checkedNode: {}
      });
      // data = {
      //   username: "admin",
      //   password: "123456",
      //   'Access-Token': "458764c6861d751cf593ef0f34103a054a13f33e",
      //   avatar: "",
      //   cid: 8042,
      //   company: "客户001",
      //   last_login_ip: "1881150564",
      //   last_login_time: 1581490808,
      //   nickname: "超级管理员",
      //   role: "1",
      //   role_name: "超级管理员",
      //   uid: 1
      // }


			const roleStrList = data.role.split(',');
      const roleList = roleStrList.length > 0 ? roleStrList.map(v => parseInt(v)) : [];
      // console.log('LogInPage roleList:',roleList);
			this.$store.commit('setUser',{
				username: this.username,
        password: this.password,
        'Access-Token': data['Access-Token'],
        avatar: data.avatar,
        cid: data.cid,
        company: data.company,
        // last_login_ip: data.last_login_ip,
        // last_login_time: data.last_login_time,
        nickname: data.nickname,
        role: data.role,
        roleList: roleList,
        role_name: data.role_name,
        uid: data.uid
			});
      this.$router.push({ name: 'MainPage' });
    },
    /*--------------------------- ↓ 存储cookie ---------------------------*/
    setCookie(){
      this.globalFn.clearCookie();
      const logInTime = 7*24*60*60*1000; // 1个星期
      let date = new Date();
      // 可下次登录时间长度，单位毫米，此处为1个星期
      date.setTime(date.getTime() + logInTime);
      document.cookie = 'username='+this.username+';expires='+date.toGMTString();
      document.cookie = 'password='+this.password+';expires='+date.toGMTString();
      document.cookie = 'isAutoLogIn='+this.isAutoLogIn+';expires='+date.toGMTString();
    },
    /*------------------------- ↓ 映射store中函数 ------------------------*/
    ...mapMutations([
      'setLogonStatus',
      'setAsideTree',
      'setFullSizeLoading'
    ])
  }
}
</script>
<style lang="less">
.LogInPage-wrap{
  background: var(--clrLogBg);
  ul.log-wrap{
    width: 60%;
    height: 700px;
    li.left-img{
      background: #fff url(../assets/img/logBoxBg.png) center/contain no-repeat;
      width: 60%;
      border-radius: 8px 0 0 8px;
    }
    li.right-log-wrap{
      width: 40%;
			background: #fff;
      border-radius: 0 8px 8px 0;
      position: relative;
      img.cloud-img{
        position: absolute;
        right: -70px;
        top: 78px;
      }
      /* ↓ 登录区域 */
      .log-box{
        width: 80%;
				color: #333333;
        h4.title{
					font-size: 25px;
					font-weight: normal;
					margin-bottom: 5px;
				}
				h6.sub-title{
					font-size: 12px;
					font-weight: normal;
					margin-bottom: 60px;
				}
        .inp-box{
          position: relative;
          border-bottom: 2px solid var(--clrInpBorder);
          margin-bottom: 40px;
          i.label-icon{
            font-size: 18px;
            line-height: 40px;
            padding-left: 5px;
          }
          input.inp{
            font-size: 18px;
            line-height: 40px;
            border: 0;
            color: var(--clrFont);
          }
          i.iconfont.toggle-seen-btn{
            width:40px;
            min-width: 40px;
            max-width: 40px;
            font-size: 18px;
						line-height: 40px;
						cursor: pointer;
          }
          i.iconfont.toggle-seen-btn:active{
            background:rgba(0,0,0,0.05);
          }
        }
        .inp-box.PW-inp-box{
          margin-bottom: 15px;
        }
        .inp-box.focus{
          color: var(--clrLogBg);
          border-bottom: 2px solid var(--clrLogBg);
        }
        .autoLog-box{
          margin-bottom: 30px;
        }
        .logIn-btn-wrap{
          position: relative;
          .logIn-btn{
            cursor: pointer;
            text-align: center;
            letter-spacing: 2px;
            width:270px;
            height: 50.25px;
            box-sizing: border-box;
            border: 0;
            line-height: 39px;
            background: url(../assets/img/logBtn.png) center/contain no-repeat;
            color: #fff;
          }
          .logIn-btn:hover{
            background: url(../assets/img/logBtnHover.png) center/contain no-repeat;
          }
          .logIn-btn:active{
            background: url(../assets/img/logBtnActive.png) center/contain no-repeat;
          }
          .logIn-btn.disabled{
            background: url(../assets/img/logBtnDisabled.png) center/contain no-repeat;
          }
          i.iconfont.icon-loading.circle-animate{
            position: absolute;
            top: 4px;
            font-size: 30px;
          }
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/LogInPage.vue